import { render } from "./YourySchoolSearch.vue?vue&type=template&id=c4b527f0&scoped=true"
import script from "./YourySchoolSearch.vue?vue&type=script&lang=js"
export * from "./YourySchoolSearch.vue?vue&type=script&lang=js"

import "primevue/resources/themes/bootstrap4-light-blue/theme.css?vue&type=style&index=0&lang=css"
import "./YourySchoolSearch.vue?vue&type=style&index=1&id=c4b527f0&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/youry.co/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b527f0"]])

export default __exports__